import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import SitePage, { styles, T, ACCENT } from '../components/site/SitePage';

const NotFoundPage = () => (
  <SitePage>
    <SEO title="Page introuvable" description="Cette page n'existe pas." noindex />
    <section style={{ ...styles.narrow, padding: '96px 24px', display: 'flex', flexDirection: 'column', gap: 20 }}>
      <p style={{ ...styles.kicker, color: '#C2410C', fontSize: 15 }}>#REF!</p>
      <h1 style={styles.h1}>Cette page n'existe pas.</h1>
      <p style={styles.lead}>Comme une formule Excel qui pointe vers une cellule supprimée. Les bonnes pages sont par ici :</p>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        <Link to="/" className="lift" style={styles.button}>Retour à l'accueil</Link>
        <Link to="/blog" className="lift" style={{ ...styles.button, background: '#FFFFFF', color: T.ink, border: `1px solid ${T.ink}`, fontWeight: 600 }}>Lire le blog</Link>
      </div>
      <p style={{ margin: 0, fontFamily: T.mono, fontSize: 13, color: T.faint }}>Ou écrivez-moi : <a href="mailto:hello@autoria.dev" style={{ color: ACCENT }}>hello@autoria.dev</a></p>
    </section>
  </SitePage>
);

export default NotFoundPage;
